import { CtaItem } from 'src/app/content-blocks/models';
import { randomExampleContent } from './example-data';
import { Event } from 'src/app/events/models';
import { News } from 'src/app/news/models';
import { FaqCategory, FaqItem } from 'src/app/faq/models';
import { Department } from 'src/app/location/models';
import { Location } from 'src/app/location/models';
import { MuseumCollection } from 'src/app/museum-collections/models';
import { Slider } from 'src/app/slider/models';
import { dateRange } from './example-content';
import { image } from './example-images';

//FaqCategory {
//  id: number;
//  name: string;
//  icon: string;
//  department: Department;
//  order: number;
//}

export const exampleDepartmentsTitles = ['Bibliotheek', 'ExperienceLab', 'Museum', 'Archief'];

export const exampleDepartments: Department[] = Array.from({ length: exampleDepartmentsTitles.length }, (_, i) => {
  return {
    id: i,
    name: exampleDepartmentsTitles[i],
    openingTimes: [],
    order: i,
    hideOpeningTimes: false,
  };
});

export const exampleFaqCats: FaqCategory[] = Array.from({ length: 25 }, (_, i) => {
  return {
    id: i,
    name: randomExampleContent('word'),
    icon: '',
    department: exampleDepartments[i % exampleDepartments.length],
    order: i,
  };
});

export const exampleFaqs: FaqItem[] = Array.from({ length: 99 }, (_, i) => {
  return {
    id: i,
    question: randomExampleContent('title') + '?',
    answer: randomExampleContent('wysiwygSimpleShort'),
    category: exampleFaqCats[Math.floor(Math.random() * exampleFaqCats.length)],
    order: i,
  };
});

export const exampleCtaCards: CtaItem[] = Array.from({ length: 4 }, (_, i) => {
  return {
    id: i,
    text: randomExampleContent('paragraph', true),
    title: randomExampleContent('title'),
    image: null,
    button: randomExampleContent('button'),
    secondaryButton: randomExampleContent('button', true),
    smallImage: Math.random() > 0.5,
  };
});

export const exampleEvents: Event[] = dateRange.map((dates, i) => {
  return {
    id: i + 1,
    eventType: {
      id: 2,
      name: randomExampleContent('category'),
    },
    title: randomExampleContent('title'),
    description: randomExampleContent('wysiwyg'),
    text: randomExampleContent('wysiwygSimpleShort', true),
    label: 'Label',
    image: randomExampleContent('image', true),
    videoUrl: randomExampleContent('video', true),
    startDate: dates.startDate.toString(),
    endDate: dates.endDate?.toString() || null,
    featured: false,
    trackingKey: `${i + 1}_${dates.startDate.toString()}`,
    displayEventDates: true,
    displayEventStartTime: true,
    displayEventEndTime: true,
    order: i,
  };
});

export const exampleMetaData = {
  title: randomExampleContent('title'),
  description: randomExampleContent('paragraph'),
  keywords: [],
  imageUrl: '',
};

export const exampleNews: News[] = Array.from({ length: 10 }, (_, i) => {
  return {
    id: i,
    title: randomExampleContent('title'),
    subtitle: randomExampleContent('title'),
    intro: randomExampleContent('paragraph'),
    text: randomExampleContent('wysiwygSimpleShort', true),
    image: randomExampleContent('image', true),
    videoUrl: randomExampleContent('video', true),
    publicationDate: new Date().toString(),
    lastEditDate: new Date().toString(),
    featured: false,
    url: ['/nieuws', '1', 'titel'],
    routerLink: ['/nieuws', '1', 'titel'],
    metaData: exampleMetaData,
    urlString: '/nieuws/1/titel',
  };
});

export const exampleCollections: MuseumCollection[] = Array.from({ length: 5 }, (_, i) => {
  return {
    id: i,
    title: randomExampleContent('title'),
    subtitle: randomExampleContent('title'),
    intro: randomExampleContent('paragraph'),
    text: randomExampleContent('wysiwygSimpleShort', true),
    image: randomExampleContent('image', true),
    gallery: [randomExampleContent('image'), randomExampleContent('image'), randomExampleContent('image')],
    videoUrl: null,
    metaData: exampleMetaData,
    url: ['/collectie', '1', 'titel'],
    order: 1,
  };
});

export const exampleLocations: Location[] = [
  {
    id: 1,
    name: 'CODA',
    geoLocation: {
      label: 'Vosselmanstraat 299 \n7311 CL Apeldoorn',
      lat: 52.2154179,
      lng: 5.9584573,
    },
    text: '<h4>Contact</h4><p>055 526 84 00<br><a href="mailto:mail@coda-apeldoorn.nl">mail@coda-apeldoorn.nl</a></p>',
    isExternalLocation: false,
    departments: [
      {
        id: 1,
        name: 'Centrale Bibliotheek',
        order: 0,
        hideOpeningTimes: false,
        openingTimes: [
          {
            day: 1,
            openingTimes: 'Gesloten*',
          },
          {
            day: 2,
            openingTimes: '10:00 - 17:30 uur',
          },
          {
            day: 3,
            openingTimes: 'Gesloten*',
          },
          {
            day: 4,
            openingTimes: '10:00 - 17:30 uur',
          },
          {
            day: 5,
            openingTimes: '10:00 - 17:30 uur',
          },
          {
            day: 6,
            openingTimes: '10:00 - 17:30 uur',
          },
          {
            day: 0,
            openingTimes: 'Gesloten*',
          },
        ],
      },
      {
        id: 2,
        name: 'Museum',
        order: 1,
        hideOpeningTimes: false,
        openingTimes: [
          {
            day: 1,
            openingTimes: 'Gesloten*',
          },
          {
            day: 2,
            openingTimes: '10.00 - 17.30 uur',
          },
          {
            day: 3,
            openingTimes: '10.00 - 17.30 uur',
          },
          {
            day: 4,
            openingTimes: '10.00 - 17.30 uur',
          },
          {
            day: 5,
            openingTimes: '10.00 - 17.30 uur',
          },
          {
            day: 6,
            openingTimes: '10.00 - 17.30 uur',
          },
          {
            day: 0,
            openingTimes: '11.00 - 17.30 uur',
          },
        ],
      },
      {
        id: 3,
        name: 'Archief',
        order: 2,
        hideOpeningTimes: false,
        openingTimes: [
          {
            day: 1,
            openingTimes: 'Gesloten*',
          },
          {
            day: 2,
            openingTimes: '10.00 - 17.30 uur',
          },
          {
            day: 3,
            openingTimes: '10.00 - 17.30 uur',
          },
          {
            day: 4,
            openingTimes: '10.00 - 17.30 uur',
          },
          {
            day: 5,
            openingTimes: 'Gesloten*',
          },
          {
            day: 6,
            openingTimes: 'Gesloten*',
          },
          {
            day: 0,
            openingTimes: 'Gesloten*',
          },
        ],
      },
      {
        id: 4,
        name: 'ExperienceLab',
        order: 3,
        hideOpeningTimes: false,
        openingTimes: [
          {
            day: 1,
            openingTimes: '10.00 - 16.00 uur',
          },
          {
            day: 2,
            openingTimes: 'Gesloten*',
          },
          {
            day: 3,
            openingTimes: '14.00 - 16.00 uur',
          },
          {
            day: 4,
            openingTimes: 'Gesloten*',
          },
          {
            day: 5,
            openingTimes: '10.00 - 16.00 uur',
          },
          {
            day: 6,
            openingTimes: '10.00 - 16.00 uur',
          },
          {
            day: 0,
            openingTimes: 'Gesloten*',
          },
        ],
      },
    ],
    alert: {
      title: 'Testmelding (uitgelichte locatie)',
      text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
    },
  },
  {
    id: 5,
    name: 'CODA de maten',
    geoLocation: {
      label: 'Violierenplein 102',
      lat: 52.1935484,
      lng: 6.003732400000001,
    },
    text: '<h4>Contact</h4><p>06-11 18 21 45</p>',
    isExternalLocation: true,
    alert: {
      title: 'Testmelding (niet-uitgelichte locatie)',
      text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>',
    },
    departments: [
      {
        id: 6,
        name: 'Bibliotheek',
        order: 0,
        hideOpeningTimes: false,
        openingTimes: [
          {
            day: 1,
            openingTimes: '13:00 - 17:30 uur',
          },
          {
            day: 2,
            openingTimes: '10:00 - 17:30 uur',
          },
          {
            day: 3,
            openingTimes: '13:00 - 17:30 uur',
          },
          {
            day: 4,
            openingTimes: '13:00 - 17:30 uur',
          },
          {
            day: 5,
            openingTimes: '13:00 - 17:30 uur',
          },
          {
            day: 6,
            openingTimes: '10:00 - 16:00 uur',
          },
          {
            day: 0,
            openingTimes: 'Gesloten*',
          },
        ],
      },
    ],
  },
  {
    id: 6,
    name: 'PCBO Prinses Margrietschool',
    geoLocation: {
      label: 'Sluisoordlaan 198',
      lat: 52.2251507,
      lng: 5.9831997,
    },
    text: '<h4>Contact</h4><p>06-21-51-81-56</p><p><strong>Let op: </strong>in de zomervakantie alleen op maandag geopend.</p>',
    isExternalLocation: true,
    departments: [
      {
        id: 7,
        name: 'Jeugd- en Buurtbibliotheek',
        order: 0,
        hideOpeningTimes: false,
        openingTimes: [
          {
            day: 1,
            openingTimes: '14:00 - 17:00 uur',
          },
          {
            day: 2,
            openingTimes: 'Gesloten*',
          },
          {
            day: 3,
            openingTimes: '11:00 - 17:00 uur',
          },
          {
            day: 4,
            openingTimes: 'Gesloten*',
          },
          {
            day: 5,
            openingTimes: '14:00 - 17:00 uur',
          },
          {
            day: 6,
            openingTimes: 'Gesloten*',
          },
          {
            day: 0,
            openingTimes: 'Gesloten*',
          },
        ],
      },
    ],
  },
  {
    id: 8,
    name: 'PCBO De Regenboog',
    geoLocation: {
      label: 'Keerkring 70',
      lat: 52.2168273,
      lng: 6.006530800000001,
    },
    text: '<p><strong>Let op:</strong> in de zomervakantie alleen op maandag geopend.</p>',
    isExternalLocation: true,
    departments: [
      {
        id: 9,
        name: 'Jeugd- en Buurtbibliotheek',
        order: 0,
        hideOpeningTimes: false,
        openingTimes: [
          {
            day: 1,
            openingTimes: '14:00 - 17:00 uur',
          },
          {
            day: 2,
            openingTimes: 'Gesloten*',
          },
          {
            day: 3,
            openingTimes: '11:00 - 17:00 uur',
          },
          {
            day: 4,
            openingTimes: 'Gesloten*',
          },
          {
            day: 5,
            openingTimes: '14:00 - 17:00 uur',
          },
          {
            day: 6,
            openingTimes: 'Gesloten*',
          },
          {
            day: 0,
            openingTimes: 'Gesloten*',
          },
        ],
      },
    ],
  },
  {
    id: 9,
    name: 'CODA dok Zuid',
    geoLocation: {
      label: '1e Wormenseweg 460',
      lat: 52.1923201,
      lng: 5.973277599999999,
    },
    text: null,
    isExternalLocation: true,
    departments: [
      {
        id: 10,
        name: 'Bibliotheek',
        order: 0,
        hideOpeningTimes: false,
        openingTimes: [
          {
            day: 1,
            openingTimes: '13:00 - 20:30 uur',
          },
          {
            day: 2,
            openingTimes: '13:00 - 17:30 uur',
          },
          {
            day: 3,
            openingTimes: '13:00 - 17:30 uur',
          },
          {
            day: 4,
            openingTimes: '13:00 - 17:30 uur',
          },
          {
            day: 5,
            openingTimes: '13:00 - 17:30 uur',
          },
          {
            day: 6,
            openingTimes: 'Gesloten*',
          },
          {
            day: 0,
            openingTimes: 'Gesloten*',
          },
        ],
      },
    ],
  },
];

export const exampleSlider: Slider = {
  id: 0,
  title: randomExampleContent('title'),
  intro: randomExampleContent('title', true),
  galleryType: 'type--advanced',
  hideTitle: false,
  slides: Array.from({ length: 14 }, (_, i) => {
    return {
      id: i,
      title: randomExampleContent('title'),
      //image: randomExampleContent('image'),
      url: image[i % image.length].url,
      caption: randomExampleContent('word', true),
      order: i,
      publish: true,
    };
  }),
};
